import { Container, Row, Col } from 'react-bootstrap';
import SocialIcons from './SocialIcons';

function Footer() {
  return (
    <footer id="footer" className="footer">
      <Container fluid style={{ background: '#000', paddingTop: '10em' }}>
        <Row style={{ display: 'none' }}>
          <Col>
            <Container>
              <Row className="align-items-center">
                <Col md={6} className="d-flex align-items-center">
                  <span className='cloister-black title'>Agência BlackStar</span>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <SocialIcons />
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col style={{ backgroundColor: '#1b1b1b', color: '#FFF', padding: '20px' }}>
            <p className="text-center mb-0">© {new Date().getFullYear()} Agência BlackStar. Todos os direitos reservados.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer